import React from 'react'
import styled from '@emotion/styled'

import GoodNovelty from '../GoodNovelty'

const Root = styled.h3`
  margin: 0;
  font-family: Merriweather, serif;
  font-size: ${({size}) => size === 'normal' ? '15px' : '13px'};
  line-height: 1.7;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.9);
`

const GoodTitle = ({
  good: {
    title,
    trimmedTitle,
    isNew,
  },
  size = 'normal',
  full = false
}) => {
  return <Root size={size}>
    <GoodNovelty isNew={isNew} size={size}/>
    <span dangerouslySetInnerHTML={{__html: full ? title : trimmedTitle}} title={title}/>
  </Root>
}

export default GoodTitle
